import React, { useState } from 'react';
import { Box, useMediaQuery, useTheme, Fade } from '@mui/material';
import { Outlet, useLocation } from 'react-router-dom';
import Navbar from './Navbar';
import Sidebar from './Sidebar';
import ProfileCompletionModal from '../common/ProfileCompletionModal';

const DRAWER_WIDTH = 260;

export default function Layout() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  const handleDrawerToggle = () => setMobileOpen(!mobileOpen);

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh', bgcolor: 'background.default' }}>
      <Sidebar
        drawerWidth={DRAWER_WIDTH}
        mobileOpen={mobileOpen}
        onClose={() => setMobileOpen(false)}
        isMobile={isMobile}
      />
      <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', minWidth: 0 }}>
        <Navbar drawerWidth={DRAWER_WIDTH} onMenuClick={handleDrawerToggle} isMobile={isMobile} />
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: { xs: 2, md: 3 },
            mt: '64px',
            maxWidth: '100%',
            overflow: 'auto'
          }}
        >
          <Fade in key={location.pathname} timeout={250}>
            <Box>
              <Outlet />
            </Box>
          </Fade>
        </Box>
      </Box>
      <ProfileCompletionModal />
    </Box>
  );
}
